// src/utils/codeGenerator.util.ts
export const generateProcedureCode = (): string => {
  const randomNumber = Math.floor(10000 + Math.random() * 90000)
  return `PR${randomNumber}`
}
